export default function isLogScaleAllowed(data) {
  if (!data.categoriesAreDates) return false;
  return !data.series.some((s, index) => {
    if (index === 0 && data.firstColumnAsCategories) return false;
    return s.data.some((d) => d.y <= 0 && d.y !== null);
  });
}
